/**
 * Get Custom Palette options
 *
 * @param {Array<Record<"colorIntention" | "colorPropertyKey" | "colorPropertyValue", any>>} paletteOptions
 */
function getCustomPalette(paletteOptions) {
  const palette = {
    primary: {},
    secondary: {},
    error: {},
    warning: {},
    info: {},
    success: {},
    text: {},
  };

  // Parse palette config from server
  for (const currentRecord of paletteOptions) {
    const colorIntention = currentRecord["colorIntention"];
    const colorPropertyKey = currentRecord["colorPropertyKey"];
    const colorValue = currentRecord["colorPropertyValue"];
    palette[colorIntention][colorPropertyKey] = colorValue;
  }

  // Under palette roles, remove if there are no subindexes.
  // {
  //   primary: { foo: 'bar'},
  //   secondary: {}, // <- Delete this
  //   text: { foo: 'bar' }
  // }
  for (const colorIntention in palette) {
    if (Object.keys(palette[colorIntention]).length === 0) {
      delete palette[colorIntention];
    }
  }

  return palette;
}

export const CyPalette = {
  getCustomPalette,
};



// WEBPACK FOOTER //
// ./src/utilities/palette.js